import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "修改TTL",
    modelValue: _ctx.selfVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selfVisible) = $event)),
    "close-on-press-escape": false,
    "close-on-click-modal": false,
    "custom-class": "dialog-width-small",
    center: "",
    top: "15vh",
    onClose: _ctx.handleClose,
    onOpen: _ctx.handleOpen
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, {
          size: "default",
          onClick: _ctx.handleClose
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 取 消 ")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "default",
          onClick: _ctx.handleSave
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 确 定 ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        inline: false,
        "label-width": "100px",
        rules: _ctx.rules,
        model: _ctx.formData,
        ref: "formRef",
        size: "default"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "key: ",
            prop: "key",
            style: {"display":"none"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.key,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.key) = $event)),
                modelModifiers: { trim: true }
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "ttl：",
            prop: "ttl"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InputNumber, {
                placeholder: "过期时间 单位/秒",
                modelValue: _ctx.formData.ttl,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.ttl) = $event))
              }, {
                append: _withCtx(() => [
                  _createTextVNode(" 秒 ")
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _: 1
  }, 8, ["modelValue", "onClose", "onOpen"]))
}